import { render, staticRenderFns } from "./OTSTechnicalList.vue?vue&type=template&id=b9ff2256&scoped=true"
import script from "./OTSTechnicalList.vue?vue&type=script&lang=js"
export * from "./OTSTechnicalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ff2256",
  null
  
)

export default component.exports